import React, {useEffect, useState} from 'react';
import {Flex, message} from "antd";
import CalendarComponent from "../../../../components/Calendar/Calendar";

const HomePage = () => {
    return (
        <Flex style={{width: "100%"}} align={"center"} justify={"center"} wrap={"wrap"} gap={10}>
            <CalendarComponent/>
        </Flex>
    );
};

export default HomePage;